import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   position: relative;
   
   .line {
      position: relative;
      display: flex;
      align-items: center;
      margin: 30px 0 15px;
      font-size: 16px;
      white-space: nowrap;

      &::before {
         content: '';
         width: 100%;
         height: 1px;
         background-color: rgb(200, 200, 200);
         margin-right: 15px;
      }
      &::after {
         content: '';
         width: 100%;
         height: 1px;
         background-color: rgb(200, 200, 200);
         margin-left: 15px;
      }
      span {
         opacity: 0.6;
      }
   }
`;